import landSpeckData from "./Guides/LandSpeck";
import GuideRenderer from "../../components/wikiComponents/GuideRenderer";

const LandSpeckGuide = () => {
  return <GuideRenderer url="lands" guideData={landSpeckData} />;
};

export default LandSpeckGuide;
